import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { useNavigate } from "react-router-dom";
import { LOGOS_URL } from '../../config';
import useApi from '../../hooks/useApi';
import icon from '../../assets/default.jpg';

const HomeAgent = ({ user, archive }) => {
    const navigate = useNavigate();
	const { t, i18n } = useTranslation();
    const lang = i18n.language;
    //const [ isArchive, setIsArchive ] = useState(false);
    const [ events, setEvents ] = useState([]);
    // eslint-disable-next-line
    const [ params, setParams ] = useState({ agent: user._id });
	const [ data, error, isLoading ] = useApi({ type: 'get', method: '/agent2event', params });
/*    
    useEffect(() => {
        if(!data) return;
        const archive = data.agent2event.filter(d => d.event.is_archived === true);
        if(archive.length > 0) setIsArchive(true);
    }, [ data ]);
*/
    useEffect(() => {
        if(!data) return;
        const events = data.agent2event.filter(d => d.event.is_archived === archive).map(d => d.event);
        setEvents(events);
    }, [ data, archive ]);

	return (
    <div>
        <h1>{archive ? t('home.archive') : t('home.myevents')}</h1>
        {error && <div className='error'>{t(error)}</div>}
        {isLoading && <div>{t('common.loading')}</div>}

        {events.length ?
        <React.Fragment>
            <div className='grid'>
            {events.map(event => (
                <div
                    key={event._id}
                    className='item' onClick={() => navigate('/cabinet/exhibitorlistbyevent/' + event._id)}
                >
                    <img
                        alt='icon'
                        className='icon'
                        src={event.logo ? LOGOS_URL + event.logo.base + event.logo.name : icon}
                    />
                    <div className='text'>{event.name[lang]}</div>
                </div>
            ))}
            </div> 
        </React.Fragment> : <p>{t('home.noevents')}</p>}
    </div>
	);
};

HomeAgent.propTypes = {
    user: PropTypes.object.isRequired,
};

export default HomeAgent;
